<mat-dialog-content class="mat-typography">
    <h2>Ajout d'un type d'équipement</h2>
    <form class="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full px-8" [formGroup]="equipementForm" (ngSubmit)="onFormSubmit()">
        <mat-form-field>
            <mat-label>Équipement</mat-label>
            <mat-select matSelect formControlName="equipement_id">
                <mat-option *ngFor="let equipement of equipements" [value]="equipement.id">
                    {{equipement.no_equipement}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Pièce</mat-label>
            <mat-select matSelect formControlName="piece_id">
                <mat-option *ngFor="let piece of pieces" [value]="piece.id">
                    {{piece.nom_piece}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Date d’installation</mat-label>
            <input type="date" matInput formControlName="date_installation">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Date de récupération</mat-label>
            <input type="date" matInput formControlName="date_recuperation">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Heure DH</mat-label>
            <input type="text" matInput formControlName="heuredh">
        </mat-form-field>
        
        <mat-form-field>
            <mat-label>Technicien</mat-label>
            <mat-select matSelect formControlName="user_id">
                <mat-option *ngFor="let technicien of techniciens" [value]="technicien.id">
                    {{technicien.prenom}} {{technicien.nom}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
